import { type InsuranceCorporateIdentity } from "../types";

export function WurthLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M430.943 214.227H79V63H225.907V122.222H285.093V63H432V214.227H430.943ZM284.036 389.778V449C368.587 433.137 430.943 360.167 430.943 277.679V274.507H79V277.679C79 359.11 141.356 432.079 225.907 447.942V388.721H284.036V389.778Z"
        fill="white"
      />
    </svg>
  );
}

export const Wurth: InsuranceCorporateIdentity = {
  id: "wurth",
  name: "Würth",
  logo: WurthLogo,
  backgroundColor: "#CC0000",
  textColor: "#FFFFFF",
  wildcard: { or: ["würth", "wurth", "wuerth"] },
  type: "statutory",
};
